import React, { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTreeFilterAndOrder } from 'src/ui';
import { T } from '@transifex/react';
import { PageHeading } from 'src/components/layout/PageHeading';

import { Layout1 } from '../../../../layout';

import { OpenTicketsOnPropertyAlert } from '../../../../shared/OpenTicketsOnPropertyAlert';

import { ApiWrapper } from './api-wrapper';

import { routingMap } from '../../../../../routing/routing-map';

import { useCompany } from 'src/app/Company.store';
import { filterSuppressedTickets } from 'src/api/helpers/suppressedTickets';
import { useGetToken } from '../../../../../api/config';
import { PropertyContext } from '../../../../../context/property-context';
import { GetTickets } from '../../../../shared/api/ticket';

import { columns, Key } from './ui';

const Homepage = () => {
  const token = useGetToken();
  const { id: propertyId } = useContext(PropertyContext);
  const { hostname } = useCompany();

  const { data: ticketsResp } = useQuery({
    queryKey: ['get-container-tickets', propertyId],
    queryFn: () =>
      GetTickets({
        property_id: propertyId,
        token,
        only_open: true,
        property_level_only: true,
      }),
  });
  const tickets: $TSFixMe[] = filterSuppressedTickets(
    (ticketsResp as $TSFixMe)?.data ?? [],
    hostname
  );

  const { state: autoState, jsx } = useTreeFilterAndOrder<Key>({
    columns,
    hideColumns: ['wasteFraction'],
    init: {
      checked: [
        'containerType',
        'pickupSetting',
        'containerId',
        'weekDay',
        'nextEmptying',
        'price',
      ],
      order: [
        'containerType',
        'pickupSetting',
        'containerId',
        'weekDay',
        'nextEmptying',
        'price',
      ],
    },
    key: 'CRM.container.table',
    buttonProps: { style: { marginLeft: 'auto' } },
  });

  return (
    <Layout1
      mainContent={
        <div>
          <div className="wh-ui mb-6">
            <PageHeading
              title={<T _str="Containers" />}
              subtitle={
                <T _str="View the containers registered to your property." />
              }
            />
          </div>
          {tickets.length > 0 && (
            <OpenTicketsOnPropertyAlert
              style={{ marginBottom: '1rem' }}
              linkTo={routingMap.app.containers._}
              tickets={tickets}
            />
          )}
          <ApiWrapper jsx={jsx} autoState={autoState} />
        </div>
      }
    />
  );
};

export default Homepage;
